import { application } from "./application";
import { registerControllers } from "stimulus-vite-helpers";

const controllers = import.meta.glob("./**/*_controller.js", { eager: true });
registerControllers(application, controllers);

import Sortable from "@stimulus-components/sortable";
application.register("sortable", Sortable);

application.debug =
  document.head.querySelector(`meta[name="env"]`)?.content === "development";
